// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__31lWs","noInteraction":"EventWrapper_noInteraction__3qKlg","pointerPassthrough":"EventWrapper_pointerPassthrough__2r97C"};